module.exports = __webpack_public_path__ + "static/media/clock.fe917847.svg";